import partnerFrame from "@comp/iframes/partners/IFrame.vue";
import Vue from "vue";
import VueMask from "v-mask";
import Vuelidate from "vuelidate";
import { ZiggyVue } from "ziggy-js";
import VueI18n from "vue-i18n";
import injectSprite from "../inject-sprite.js";

// Fetched, not imported at the top: a static import puts ~590 KB of SDK into
// this entry, which is render-blocking inside a partner's page. It still
// initialises long before a request can fail.
import("@utils/sentry").then(({ initSentry }) => initSentry()).catch(() => {});

Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(ZiggyVue);

import en from "@/locales/en.json";

const i18n = new VueI18n({
    locale: "en",
    fallbackLocale: "en",
    messages: {
        en,
    },
});

new Vue({
    el: "#frame",
    components: { partnerFrame },
    i18n,
});

injectSprite();
